import { DATA_Address, DATA_AddressLines } from '@api-new/common';

export const dataAddressToAddressLinesAdapter = (addressData: DATA_Address): DATA_AddressLines => {
  return {
    lines: [
      `${addressData?.buildingName || ''} ${addressData?.companyName || ''}`.trim(),
      `${addressData?.buildingNumber || ''} ${addressData?.street}`.trim(),
      `${addressData?.city}`,
      `${addressData?.postcode}`,
    ].filter((l) => l),
  };
};
